export const isUserAdmin = () => {
  const userRole = localStorage.getItem('role');
  return userRole === 'admin';
}; 